<template>
  <div class="invoice-container" :class="wrapperClass">
    <icon-view class="ml-2" icon="fa fa-flag" title="Discusión de Plan" />
    <validation-observer ref="invoicePlan">
      <div class="row mx-0 ml-md-4">
        <div class="col-12 col-md-3 mt-3">
          <label for="invoice">
            ¿Estará facturando la discusión del plan?
          </label>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              :key="model.date"
              v-model="model.invoice"
              custom-error-msg="Favor marcar si estará facturando la discusión del plan."
              :disabled="!continueEditing"
              :error="Boolean(errors[0])"
              is-inline
              name="invoice"
              :options="defaultOptions"
              @input="invoiceChange"
            />
          </validation-provider>
        </div>
        <template v-if="model.invoice && model.invoice.value">
          <div class="col-12 mt-3 col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="serviceSpecialist"
                v-model="model.referralOverrideSpecialist"
                :disabled="!continueEditing"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Especialista que discutió el plan: "
                name="serviceSpecilist"
                :options="specialists"
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-3 col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.date"
                class-container=""
                custom-error-msg="La fecha es requerida."
                :disabled="!continueEditing"
                :error="errors[0]"
                label="Fecha:"
                :max-date="maxDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-3 col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-time-picker
                v-model="model.startTime"
                class-container=""
                custom-error-msg="La hora desde es requerida."
                :disabled="!continueEditing"
                end-time-value="19:55"
                :error="errors[0]"
                label="Hora Desde:"
                placeholder="HH:mm"
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-3 col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-time-picker
                v-model="model.endTime"
                :class-container="invalidHour ? 'invalidated' : ''"
                custom-error-msg="La hora hasta es requerida."
                :disabled="!continueEditing"
                end-time-value="20:00"
                :error="errors[0]"
                label="Hora Hasta:"
                placeholder="HH:mm"
              />
              <custom-error
                v-if="invalidHour"
                message="La hora hasta no puede ser menor a la desde."
                variant="no-border"
              />
            </validation-provider>
          </div>
        </template>
        <div v-if="!readOnly" class="col-12 mt-3">
          <template v-if="continueEditing">
            <div class="row">
              <div class="d-flex justify-content-end w-100 mr-3">
                <action-button
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger mr-md-1"
                  @click="cancel()"
                />
                <action-button
                  i="fas fa-save"
                  text="Guardar"
                  variant="success ml-md-1 mt-md-0 mt-2"
                  @click="save()"
                />
              </div>
            </div>
          </template>
          <div
            v-if="
              !onlyShowPlan &&
                !continueEditing &&
                this.userHasPermissions('interventionplan.canedit') &&
                ((isSignHubActive &&
                  !isInterventionPlanElectronicSigned &&
                  !interventionFlags.isAmending &&
                  !interventionFlags.isSubmitted &&
                  this.info.canChangeBill) ||
                  (interventionFlags.isSubmitted && this.info.canChangeBill) ||
                  (interventionFlags.isBillingSubmitted &&
                    interventionFlags.isAmending &&
                    this.info.canChangeBill) ||
                  !isSignHubActive)
            "
            class="row"
          >
            <div class="d-flex justify-content-end w-100 mr-3">
              <action-button
                i="fas fa-edit"
                text="Editar"
                variant="outline-success"
                @click="editMode()"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import CustomRadio from 'custom-radio';
import ActionButton from 'ActionButton';
import CustomTimePicker from 'custom-time-picker';
import IconView from 'icon-view';
import moment from 'moment';
import CustomError from 'custom-error';
import CustomDropDown from 'custom-drop-down';

export const OPTION_BILLING_PLAN_DISCUSSION_YES = 1;
export const OPTION_BILLING_PLAN_DISCUSSION_NO = 2;

export default {
  name: 'InvoicePlan',
  components: {
    CustomDatePicker,
    CustomRadio,
    ActionButton,
    CustomTimePicker,
    IconView,
    CustomError,
    CustomDropDown,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    maxDate: {
      type: Date,
      default: () => new Date(),
    },
    continueEditing: {
      type: Boolean,
      default: () => false,
    },
    wrapperClass: {
      type: [Object, String],
      default: () => null,
    },
    specialists: {
      type: Array,
      default: () => [],
    },
    isInterventionPlanElectronicSigned: {
      type: Boolean,
      default: () => true,
    },
    isSignHubActive: {
      type: Boolean,
      default: () => true,
    },
    onlyShowPlan: {
      type: Boolean,
      default: () => false,
    },
    isPlanAmendment: {
      type: Boolean,
      default: () => false,
    },
    interventionFlags: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    editing: true,
    model: {
      invoice: null,
      date: null,
      endTime: null,
      startTime: null,
      referralOverrideSpecialist: null,
    },
    defaultOptions: [
      {
        id: OPTION_BILLING_PLAN_DISCUSSION_YES,
        name: 'invoice-rbnt',
        value: true,
        label: 'Si',
        check: false,
      },
      {
        id: OPTION_BILLING_PLAN_DISCUSSION_NO,
        name: 'invoice-rbnt',
        value: false,
        label: 'No',
        check: false,
      },
    ],
  }),
  computed: {
    invalidHour() {
      return moment(this.model.endTime, 'HH:mm').isBefore(
        moment(this.model.startTime, 'HH:mm')
      );
    },
  },
  watch: {
    info: {
      immediate: true,
      handler(current) {
        this.initializeModel(current);
        this.editing = Object.keys(current).some(
          (prop) => current[prop] == null
        );
      },
    },
    continueEditing: {
      immediate: true,
      handler() {
        this.editing = this.continueEditing;
      },
    },
  },
  continueEditing: {
    immediate: true,
    handler() {
      this.editing = this.continueEditing;
    },
  },
  mounted() {
    this.invoiceChange();
  },
  methods: {
    initializeModel(invoice) {
      this.model = {
        date: invoice.date,
        invoice: this.defaultOptions.find(
          (o) => o.value === invoice.isPlanBilling
        ),
        endTime: invoice.endTime,
        startTime: invoice.startTime,
        referralOverrideSpecialist: invoice.referralOverrideSpecialist,
      };
    },
    async save() {
      const isValid = await this.$refs.invoicePlan.validate();
      if (!isValid || this.invalidHour) {
        this.$emit('alert');
        return;
      }
      this.$emit('save-info', this.model);
    },
    async cancel() {
      await this.editMode(false);
      this.$emit('cancel');
    },
    async editMode(editing = true) {
      if (!this.info.canChangeBill) {
        this.$emit('alert-billing-change');
        return;
      }
      await this.$refs.invoicePlan.reset();
      this.$emit('edit-mode', editing);
      this.editing = !this.editing;
    },
    invoiceChange() {
      this.$emit('is-plan-billing-change', this.model.invoice?.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.invoice-container {
  padding: 1rem 0.5rem;
  border-radius: 0.35rem;
  background: map-get($colors, 'secondary-3');
  border-left: 0.25rem solid map-get($colors, 'primary-1') !important;

  ::v-deep {
    .title-icon {
      color: map-get($colors, 'primary-1') !important;
    }
    .dot {
      background: map-get($colors, 'white') !important;
    }
  }
}
</style>
